/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { aiIntegrationsGetAnthropicInferenceConfig } from "../funcs/aiIntegrationsGetAnthropicInferenceConfig.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { AnthropicInferenceConfig } from "../models/components/anthropicinferenceconfig.js";
import {
  GetAnthropicInferenceConfigRequest,
  GetAnthropicInferenceConfigSecurity,
} from "../models/operations/getanthropicinferenceconfig.js";
import { unwrapAsync } from "../types/fp.js";
export type AnthropicInferenceConfigQueryData = AnthropicInferenceConfig;

export function prefetchAnthropicInferenceConfig(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetAnthropicInferenceConfigRequest | undefined,
  security?: GetAnthropicInferenceConfigSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAnthropicInferenceConfigQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAnthropicInferenceConfigQuery(
  client$: GramCore,
  request?: GetAnthropicInferenceConfigRequest | undefined,
  security?: GetAnthropicInferenceConfigSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<AnthropicInferenceConfigQueryData>;
} {
  return {
    queryKey: queryKeyAnthropicInferenceConfig({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function anthropicInferenceConfigQueryFn(
      ctx,
    ): Promise<AnthropicInferenceConfigQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(aiIntegrationsGetAnthropicInferenceConfig(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAnthropicInferenceConfig(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "aiIntegrations",
    "getAnthropicInferenceConfig",
    parameters,
  ];
}
